import { Collection } from 'modules/core/lib/mobx-rest'

import Currency from 'modules/settings/store/models/Currency'

class Currencies extends Collection<Currency> {
  get cacheKey(): string {
    return 'currencies'
  }

  model() {
    return Currency
  }
}

const singleton: Currencies = new Currencies()

export default singleton
